import { BrowserRouter } from "react-router-dom";
import { Router } from "./routes/index";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { AuthProvider } from "./context/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import "./i18n";

import { GlobalStyle } from "./styles/global";
import { themeColors, useColorContext } from "./styles/themes/default";
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

export function App() {
  const { themeMui, currentTheme } = useColorContext();
  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (query.meta?.errorMessage) {
          toast.error(`${query.meta.errorMessage}`);
        }
      },
    }),
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        retry: 3,
        staleTime: 5 * 60 * 1000, // 5 minutos
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      {/* @ts-ignore */}
      <StyledThemeProvider theme={themeColors[currentTheme]}>
        <MuiThemeProvider theme={themeMui}>
          <BrowserRouter>
            <AuthProvider>
              <Router />
            </AuthProvider>
          </BrowserRouter>
          {/* @ts-ignore */}
          <GlobalStyle />
        </MuiThemeProvider>
      </StyledThemeProvider>
    </QueryClientProvider>
  );
}
